import { Grid } from '@mui/material'
import React, { useState } from 'react'
import { isEmpty, showToast, validatePassword } from '../utils/AppHelper'
import { useTheme } from '@mui/material'
import AppButton from './AppButton'
import serverData from '../api/ServerData'
import { TextBold } from './TextStyling'
import PasswordPopperComponent from './PasswordPopperComponent'

export default function ChangePassword () {
  const theme = useTheme()
  const [loading, setLoading] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [formError, setFormError] = useState({})

  const validateForm = () => {
    const error = {}

    if (isEmpty(oldPassword)) {
      error.oldPassword = 'Please enter old password.'
    }

    if (isEmpty(newPassword)) {
      error.newPassword = 'Please enter new password.'
    } else if (newPassword.length < 8) {
      error.newPassword = 'Password should be 8 characters long'
    } else if (!validatePassword(newPassword)) {
      error.newPassword =
        'Password should contain atleast a letter, number and special character'
    }

    if (oldPassword === newPassword) {
      error.newPassword = 'Old and New password should not be same.'
    }

    if (isEmpty(confirmPassword)) {
      error.confirmPassword = 'Please enter confirm password.'
    } else if (newPassword !== confirmPassword) {
      error.confirmPassword = 'New and confirm password should be same.'
    }

    setFormError(error)
    return Object.keys(error).length === 0
  }

  const handleChangePassword = async () => {
    if (validateForm()) {
      setLoading(true)

      var body = {
        oldPassword,
        newPassword
      }
      await serverData.changePassword(
        body,
        data => {
          if (data.status) {
            setOldPassword('')
            setNewPassword('')
            setConfirmPassword('')
            showToast(data.message, false)
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }
  return (
    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
      <Grid item md={8} xs={12}>
        <Grid
          container
          style={{
            background: theme.palette.background.paper,
            padding: '24px',
            border: `1px solid ${theme.palette.border.main}`,
            borderRadius: '16px'
          }}
        >
          <Grid item xs={12}>
            <TextBold style={{ fontSize: '24px' }}>Change password</TextBold>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: '15px' }}>
            <PasswordPopperComponent
              password={oldPassword}
              setPassword={setOldPassword}
              formError={formError.oldPassword}
              isPopper={false}
              title={'Old password *'}
            />
          </Grid>

          <Grid item xs={12} sx={{ marginTop: '15px' }}>
            <PasswordPopperComponent
              password={newPassword}
              setPassword={setNewPassword}
              formError={formError.newPassword}
              isPopper={true}
              title={'New password *'}
            />
          </Grid>

          <Grid item xs={12} sx={{ marginTop: '15px' }}>
            <PasswordPopperComponent
              password={confirmPassword}
              setPassword={setConfirmPassword}
              formError={formError.confirmPassword}
              isPopper={false}
              title={'Confirm password *'}
            />
          </Grid>

          <Grid item xs={12} style={{ marginTop: '24px' }}>
            <AppButton
              variant='contained'
              onClick={() => handleChangePassword()}
              name='Change password'
              disabled={false}
              loading={loading}
              style={{
                textTransform: 'none',
                width: 'fit-content',
                padding: '12px 27px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 400,
                marginRight: '16px'
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
